import React__default from "react";
import { useListItem, useMergeRefs } from "@floating-ui/react";
import clsx from "clsx";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Badge } from "../badge/badge.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { TabsNavigationContext } from "./tabs-navigation-context.mjs";
const TabsNavigationItem = React__default.forwardRef(function TabsNavigationItem2(props, propRef) {
  const { setCurrentItem, behaviour } = React__default.useContext(TabsNavigationContext);
  const { ref: listRef } = useListItem();
  const { children, className, current, purpose, icon, endContent, id, ...rest } = props;
  const getIcon = () => {
    if (!icon) {
      return null;
    }
    if (typeof icon === "string") {
      return /* @__PURE__ */ React__default.createElement(Icon, { modifiers: icon, align: "middle", className: "tabs-navigation__item-icon" });
    }
    return /* @__PURE__ */ React__default.createElement(Image, { ...icon, className: "tabs-navigation__item-icon tabs-navigation__item-icon-image" });
  };
  const badgeType = React__default.useMemo(() => {
    if (purpose === "employee") {
      return current ? "employee-active" : "employee";
    }
    return current ? "primary" : "inactive";
  }, [purpose, current]);
  const setItemAsCurrent = React__default.useCallback(
    (element) => {
      if (current) {
        setCurrentItem({ purpose, element });
      }
    },
    [current, purpose, setCurrentItem]
  );
  const ref = useMergeRefs([propRef, listRef, setItemAsCurrent]);
  return /* @__PURE__ */ React__default.createElement(
    "li",
    {
      className: clsx(
        "tabs-navigation__item",
        {
          ["tabs-navigation__item--".concat(purpose)]: purpose,
          "tabs-navigation__item--icon": icon,
          "is-current": current
        },
        className
      ),
      id,
      role: behaviour === "tabs" ? "presentation" : void 0
    },
    /* @__PURE__ */ React__default.createElement(Anchor, { isUnderlined: false, "aria-current": behaviour === "list" && current ? "true" : void 0, ...rest, className: "tabs-navigation__link", ref }, getIcon(), /* @__PURE__ */ React__default.createElement("div", { className: "tabs-navigation__item-content" }, /* @__PURE__ */ React__default.createElement("div", { className: "tabs-navigation__link-inner h4" }, children), endContent && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, "("), /* @__PURE__ */ React__default.createElement(Badge, { size: "medium", text: endContent, purpose: badgeType, className: "tabs-navigation__item-tag" }), /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, ")"))))
  );
});
export {
  TabsNavigationItem
};
